import React, { useState } from "react";
import api from "../../utils/api";
import { useNavigate } from "react-router-dom";

export default function RegisterPage() {
  const [role, setRole] = useState("SEEKER");
  const [form, setForm] = useState({
    fullName: "",
    email: "",
    password: "",
    confirm: ""
  });

  const [message, setMessage] = useState("");
  const nav = useNavigate();

  function change(e) {
    const { name, value } = e.target;
    setForm(f => ({ ...f, [name]: value }));
  }

  async function submit(e) {
    e.preventDefault();

    if (form.password !== form.confirm) {
      setMessage("Passwords do not match");
      return;
    }

    try {
      await api.post("/auth/register", {
        fullName: form.fullName,
        email: form.email,
        password: form.password,
        role
      });

      setMessage(
        "Registration successful! A verification link has been sent to your email. Please verify before logging in."
      );

      // Optional UX: Redirect to login after 2–3 sec
      setTimeout(() => {
        nav("/login");
      }, 2500);

    } catch (err) {
      setMessage(err?.response?.data?.message || "Registration failed");
    }
  }

  return (
    <div className="min-h-screen flex items-start lg:items-center justify-center py-12">
      <div className="w-full max-w-md mx-auto">

        <div className="text-center mb-6">
          <img src="/logo192.png" alt="RoomVetiyo" className="mx-auto w-20 h-20" />
        </div>

        <div className="bg-white rounded-3xl shadow-soft-lg p-8">
          <h1 className="text-2xl font-extrabold text-gray-900 text-center">
            Create Account
          </h1>
          <p className="text-sm text-gray-500 text-center mt-1">
            Join RoomVetiyo today
          </p>

          {/* Feedback Message */}
          {message && (
            <div className="mt-4 p-3 text-center text-sm bg-blue-100 text-blue-700 rounded-xl">
              {message}
            </div>
          )}

          <form onSubmit={submit} className="mt-6 space-y-3">
            <label className="text-sm text-gray-700">I am a</label>

            <div className="grid grid-cols-2 gap-3">
              <button
                type="button"
                className={`p-3 rounded-xl border ${role === "SEEKER"
                  ? "border-primary bg-primary/10"
                  : "border-gray-200"
                  }`}
                onClick={() => setRole("SEEKER")}
              >
                Room Seeker
              </button>

              <button
                type="button"
                className={`p-3 rounded-xl border ${role === "OWNER"
                  ? "border-primary bg-primary/10"
                  : "border-gray-200"
                  }`}
                onClick={() => setRole("OWNER")}
              >
                Owner
              </button>
            </div>

            <input
              name="fullName"
              value={form.fullName}
              onChange={change}
              placeholder="Full name"
              className="w-full border rounded-xl p-3"
              required
            />
            <input
              name="email"
              type="email"
              value={form.email}
              onChange={change}
              placeholder="Email address"
              className="w-full border rounded-xl p-3"
              required
            />
            <input
              name="password"
              type="password"
              value={form.password}
              onChange={change}
              placeholder="Password"
              className="w-full border rounded-xl p-3"
              required
            />
            <input
              name="confirm"
              type="password"
              value={form.confirm}
              onChange={change}
              placeholder="Confirm password"
              className="w-full border rounded-xl p-3"
              required
            />

            <button className="w-full bg-primary text-white py-3 rounded-xl">
              Create Account
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
